import GroupSearchFeedbackConstants from '../constants/GroupSearchFeedbackConstants';
import FeedbackApi from '../api/FeedbackApi';
import composeSuccessMessaging from '../helpers/messaging/composeSuccessMessaging';

function startGroupSearchFeedback(bib) {
  return {
    type: GroupSearchFeedbackConstants.OPEN_FEEDBACK_OVERLAY,
    payload: {
      metadataId: bib.get('id'),
      groupSearchSummary: bib.get('groupSearchSummary'),
      searchUrl: window.location.href
    }
  };
}

function closeOverlay() {
  return {
    type: GroupSearchFeedbackConstants.CLOSE_FEEDBACK_OVERLAY
  };
}

function updateShouldMatch(shouldMatch) {
  return {
    type: GroupSearchFeedbackConstants.CHOOSE_SHOULD_MATCH,
    payload: shouldMatch
  };
}

function selectMatchingBib(bib) {
  return {
    type: GroupSearchFeedbackConstants.SELECT_MATCHING_BIB,
    payload: {
      metadataId: bib.get('id'),
      groupSearchSummary: bib.get('groupSearchSummary')
    }
  };
}

function changeMatchingBib() {
  return {
    type: GroupSearchFeedbackConstants.CHANGE_MATCHING_BIB
  };
}

function submitFeedback({ messagingId, notes }) {
  return {
    types: [
      GroupSearchFeedbackConstants.SUBMIT_FEEDBACK_REQUEST,
      GroupSearchFeedbackConstants.SUBMIT_FEEDBACK_SUCCESS,
      GroupSearchFeedbackConstants.SUBMIT_FEEDBACK_FAILURE
    ],
    payload: {
      notes
    },
    apiRequest: (state, apiClient) => {
      const shouldMatch = state.getIn(['ui', 'groupSearchFeedback', 'shouldMatch']);
      const metadataId1 = state.getIn(['ui', 'groupSearchFeedback', 'metadataId1']);
      let metadataId2 = state.getIn(['ui', 'groupSearchFeedback', 'metadataId2']);
      let groupSearchSummary2 = state.getIn(['ui', 'groupSearchFeedback', 'groupSearchSummary2']);

      if (!shouldMatch) {
        // Find a manifestation of the current item and use it as metadataId2
        metadataId2 = state
          .getIn(['search', 'catalogSearch', 'results'])
          .filter(group => group.get('manifestations').includes(metadataId1))
          .map(group => group.get('representative'))
          .first();

        groupSearchSummary2 = state.getIn(['entities', 'bibs', metadataId2, 'groupSearchSummary']);
      }

      return FeedbackApi.submitGroupSearchFeedback(
        {
          notes,
          metadataId1,
          metadataId2,
          groupSearchSummary1: state.getIn(['ui', 'groupSearchFeedback', 'groupSearchSummary1']),
          groupSearchSummary2,
          shouldMatch: state.getIn(['ui', 'groupSearchFeedback', 'shouldMatch']),
          searchUrl: state.getIn(['ui', 'groupSearchFeedback', 'searchUrl'])
        },
        apiClient
      );
    },
    apiSuccess: () => ({
      messaging: composeSuccessMessaging(messagingId, 'message_feedback_confirmed')
    })
  };
}

export default {
  startGroupSearchFeedback,
  closeOverlay,
  updateShouldMatch,
  selectMatchingBib,
  changeMatchingBib,
  submitFeedback
};
